import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'

const moduleWrapperStyle: CSSObject = {
  position: 'relative',
}

const getSidebarWrapperStyle = (
  width: number,
  isExpanded: boolean | undefined,
  showSectionOptions: boolean
): CSSObject => ({
  display: 'flex',
  flexDirection: isExpanded ? 'column' : 'row',
  left: `calc(${width}px + 20px)`,
  opacity: showSectionOptions ? 1 : 0,
  position: 'absolute',
  top: 0,
  transition: 'opacity 0.3s ease',
  visibility: showSectionOptions ? 'visible' : 'hidden',
})

const getGroupedSidebarButtonWrapper = (
  hasLinkPreview: boolean
): CSSObject => ({
  alignItems: 'center',
  backgroundColor: colors.n3.base,
  borderRadius: '4px',
  display: 'flex',
  height: '36px',
  justifyContent: 'space-between',
  marginRight: '10px',
  width: '72px',
  '.kuiper-modular-section-asset-picker-divider': {
    backgroundColor: colors.n1.base,
    border: `1px solid ${colors.n1.base}`,
    height: '28px',
  },
  '.kuiper-icon-wrapper': {
    color: hasLinkPreview ? colors.n5.base : colors.n6.base,
  },
})

const getSidebarButton = (isDragging: boolean): CSSObject => ({
  backgroundColor: isDragging ? colors.gem.blue : colors.n3.base,
  borderRadius: '3px',
  display: 'flex',
  height: '36px',
  marginBottom: '10px',
  width: '36px',
  '.kuiper-dragging-carousel-section': {
    position: 'absolute',
    top: '46px',
  },
})

const getOptionsStyling = (isDragging: boolean): CSSObject => ({
  alignItems: 'center',
  borderRadius: '4px',
  cursor: 'pointer',
  display: 'flex',
  height: '36px',
  justifyContent: 'center',
  position: 'absolute',
  width: '36px',
  color: colors.n6.base,
  '&:hover': {
    color: colors.white.base,
  },
  '.kuiper-icon-wrapper': {
    color: isDragging ? colors.white.base : colors.n6.base,
  },
})

const getPopoverStyling = (
  tooltipActive: boolean,
  isExpanded?: boolean
): CSSObject => ({
  background: 'white',
  borderRadius: '4px',
  boxShadow: '0 0 8px 2px rgba(0, 0, 0, 0.6)',
  display: tooltipActive ? 'inline-block' : 'none',
  right: '53px',
  opacity: tooltipActive ? 1 : 0,
  position: 'absolute',
  top: isExpanded ? '38px' : '-8px',
  transition: 'opacity 0.2s ease-in',
  zIndex: 10000,
  '&::after': {
    border: '10px solid white',
    borderRadius: '3px',
    content: '""',
    right: '-5px',
    position: 'absolute',
    top: '16px',
    transform: 'rotate(45deg)',
    zIndex: -1,
  },
})

const getDraggedComponent = (height: number, width: number): CSSObject => ({
  border: `2px solid ${colors.gem.blue}`,
  height: `calc(${height}px + 8px)`,
  left: `calc(-${width}px - 26px)`,
  position: 'absolute',
  top: '-6px',
  width: `calc(${width}px + 8px)`,
  zIndex: 1000,
})

const placeholderDraggedComponent: CSSObject = {
  left: '-51px',
  position: 'absolute',
  top: '4px',
}

const styles = {
  getDraggedComponent,
  getGroupedSidebarButtonWrapper,
  getOptionsStyling,
  getPopoverStyling,
  getSidebarButton,
  getSidebarWrapperStyle,
  moduleWrapperStyle,
  placeholderDraggedComponent,
}

export { styles }
